// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Auth_details {
    text-align: center;
    margin: 100px 0;
    height: calc(100vh - 200px);
}

.lang_selector {
    position: fixed;
    top: 15px;
    right: 15px;
    border: none;
    outline: none;
    cursor: pointer;

}

.lng {
    border: 1px solid #c1c1c1;
    margin: 10px;
    padding: 10px;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
}

.selcted {
    background-color: #0877BC;
    color: #fff;
    border: none;
}

.Scanner_input {
    display: flex;
    justify-content: center;
    margin: 20px 0;
}

.note_mark_title {
    font-size: 13px;
    font-weight: bold;
    margin-top: 10px;
}

.note_mark {
    font-size: 11px;
    margin: 0 20px;
}

.otp_input {
    width: 45px !important;
    height: 45px !important;
    background-color: #fff;
    outline: none;
    border: 1px solid #202226;
    border-radius: 6px;
    margin: 3px !important;
    font-size: 18px;
    text-align: center;
}

.otp_input::-webkit-outer-spin-button,
.otp_input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.otp_input:disabled {
    border: 1px solid #ccc;

}

.Voucher_button {
    display: block;
    border-radius: 6px;
    background: var;
    padding: 12px 0;
    width: 85%;
    margin: 15px auto;
    border: none;
    outline: none;
    font-size: 15px;
    color: #fff;
    cursor: pointer;

}

.Scanner_title {
    font-size: 25px;
    padding: 20px 0;
    width: 100%;
    text-align: center;
    border-radius: 10px 10px 0 0;
    color: #202226;
}

.Scanner_data_list {
    display: flex;
    justify-content: space-between;
    margin: 30px 50px;

}

.Scanner_data {
    p {
        font-size: 13px;
        color: var(--greyfont);
    }

    h2 {
        font-size: 15px;
    }
}

.verify_submitbutton {
    border: none;
    color: #fff;
    background-color: #0877BC;
    width: 80%;
    padding: 10px 0;
    border-radius: 10px;
    margin: 25px 0;
    cursor: pointer;
    font-size: 14px;
}

@media(max-width:560px) {
    .otp_input {
        width: 35px !important;
        height: 35px !important
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/common/Emailverify.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;;AAEnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,sBAAsB;;AAE1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,WAAW;IACX,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;;AAErB;;AAEA;IACI;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,sBAAsB;QACtB;IACJ;;AAEJ","sourcesContent":[".Auth_details {\n    text-align: center;\n    margin: 100px 0;\n    height: calc(100vh - 200px);\n}\n\n.lang_selector {\n    position: fixed;\n    top: 15px;\n    right: 15px;\n    border: none;\n    outline: none;\n    cursor: pointer;\n\n}\n\n.lng {\n    border: 1px solid #c1c1c1;\n    margin: 10px;\n    padding: 10px;\n    text-align: center;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.selcted {\n    background-color: #0877BC;\n    color: #fff;\n    border: none;\n}\n\n.Scanner_input {\n    display: flex;\n    justify-content: center;\n    margin: 20px 0;\n}\n\n.note_mark_title {\n    font-size: 13px;\n    font-weight: bold;\n    margin-top: 10px;\n}\n\n.note_mark {\n    font-size: 11px;\n    margin: 0 20px;\n}\n\n.otp_input {\n    width: 45px !important;\n    height: 45px !important;\n    background-color: #fff;\n    outline: none;\n    border: 1px solid #202226;\n    border-radius: 6px;\n    margin: 3px !important;\n    font-size: 18px;\n    text-align: center;\n}\n\n.otp_input::-webkit-outer-spin-button,\n.otp_input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.otp_input:disabled {\n    border: 1px solid #ccc;\n\n}\n\n.Voucher_button {\n    display: block;\n    border-radius: 6px;\n    background: var;\n    padding: 12px 0;\n    width: 85%;\n    margin: 15px auto;\n    border: none;\n    outline: none;\n    font-size: 15px;\n    color: #fff;\n    cursor: pointer;\n\n}\n\n.Scanner_title {\n    font-size: 25px;\n    padding: 20px 0;\n    width: 100%;\n    text-align: center;\n    border-radius: 10px 10px 0 0;\n    color: #202226;\n}\n\n.Scanner_data_list {\n    display: flex;\n    justify-content: space-between;\n    margin: 30px 50px;\n\n}\n\n.Scanner_data {\n    p {\n        font-size: 13px;\n        color: var(--greyfont);\n    }\n\n    h2 {\n        font-size: 15px;\n    }\n}\n\n.verify_submitbutton {\n    border: none;\n    color: #fff;\n    background-color: #0877BC;\n    width: 80%;\n    padding: 10px 0;\n    border-radius: 10px;\n    margin: 25px 0;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n@media(max-width:560px) {\n    .otp_input {\n        width: 35px !important;\n        height: 35px !important\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
